import React, {useEffect, useRef, useState} from 'react';
import {
    countNotificationByUserId,
    releaseAllCheck,
    releaseCheck,
    releaseCountable,
    selectNotificationsByUserId
} from "../../api/alarm/notificationService";
import {ScrollArea} from "../../shadCn/components/ui/scroll-area";
import {useInterval} from "../notification/useInterval";
import {useInView} from "react-intersection-observer";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {BoltSlashIcon, CheckIcon, PencilSquareIcon, WrenchIcon} from "@heroicons/react/24/solid";
import EmptyData from "../../resources/icon/empty-data.png";
import {useSelector} from "react-redux";
import {handleActiveToast} from "../sonner/ToastBasic";
import {ModalComputerRoomAccess} from "../basic/ModalComputerRoomAccess";
import {ModalEquipmentAccess} from "../basic/ModalEquipmentAccess";
import LicenseProgressBar from "../progressBar/LicenseProgressBar";
import {getLicenseCheck} from "../../api/licenseCheck/LicenseCheckService";
import {isAdmin} from "../commonmethod/CommonMethod";


const Notification = () => {
    const [notificationCount, setNotificationCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [ref, inView] = useInView();
    const [license, setLicense] = useState();

    const user = useSelector((state) => state.auth.user);

    const notificationRef = useRef(null);
    const refreshNotification = useSelector(state => state.status.refreshNotification);
    const platFrom = useSelector(state => state.auth.platFrom)

    const initialPageable = {
        size: 10,
        page: 0,
        totalElements: 0,
        totalPages: 0,
        last: false
    }
    const [pageable, setPageable] = useState(initialPageable);

    useEffect(() => {
        //외부 클릭시 userMenu 닫음
        function handleClickOutside(event) {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setIsClicked(false);
                setPageable(initialPageable);
                setNotifications([]);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [notificationRef]);

    useEffect(() => {
        if (!pageable.last) {
            if (inView || isClicked) {
                handleCallNotifications();
            }
        }
    }, [inView, isClicked]);

    useEffect(() => {
        handleCallNotifications();
    }, [refreshNotification]);

    useEffect(() => {
        handleRequestCountNotification();
    }, []);

    useEffect(() => {
        handleCallLicenseData();
    }, []);

    const handleCallLicenseData = async () => {
        const response = await getLicenseCheck();
        if (response && response.status === 200) {
            setLicense(response.data);
        }
    }

    const handleCallNotifications = async () => {
        const response = await selectNotificationsByUserId(pageable);
        if (response && response.status === 200) {
            setPageable((prev) => ({
                ...prev,
                page: response.data.last ? prev.page : prev.page + 1,
                last: response.data.last
            }));
            setNotifications(prev => [...prev, ...response.data.content]);
        }
    }

    const handleRequestCountNotification = async () => {
        const response = await countNotificationByUserId();
        if (response && response.status === 200) {
            setNotificationCount(response.data);
        }
    }
    useInterval(handleRequestCountNotification, 60000 * 5);

    const handleBellClick = () => {
        setIsClicked((prev) => !prev);
        handleReleaseCountable();
    }

    const handleReleaseCountable = () => {
        if (notificationCount > 0) {
            releaseCountable().then(response => {
                setNotificationCount(0);
            })
        }
    }

    const handleReleaseAllCheck = async () => {
        if (window.confirm("모두 읽음 처리하시겠습니까?")) {
            const response = await releaseAllCheck();
            if (response && response.status === 200) {
                setNotifications([]);
                handleActiveToast({message: "읽음 처리되었습니다."});
            }
        }
    }

    return (
        <div className="nav-icons ml-auto relative z-60 flex align-center gap-5 mr-5">

            {isAdmin(user) &&
                <LicenseProgressBar license={license} platform={platFrom} />
            }

            {platFrom !== "SRM" &&
                <div className={`flex align-center gap-5`}>

                    <ModalComputerRoomAccess isIconTrigger={true}/>
                    <ModalEquipmentAccess isIconTrigger={true}/>

                </div>
            }

            <button
                type="button"
                className="inline-flex items-center justify-center p-0 border-0 bg-transparent cursor-pointer hover:opacity-80 transition-opacity duration-200"
                title="시스템 알림"
                aria-label="시스템 알림"
                aria-expanded={isClicked}
                onClick={handleBellClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                     className="icon icon-tabler icons-tabler-outline icon-tabler-bell"
                     aria-hidden="true"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path
                        d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"/>
                    <path d="M9 17v1a3 3 0 0 0 6 0v-1"/>
                </svg>
            </button>

            {notificationCount > 0 && (
                <span className="notification-count">{notificationCount}</span>
            )}
            {isClicked && (
                <div ref={notificationRef} className={"notification"}>
                    <ScrollArea className={`${notifications.length > 8 ? 'h-[30rem]' : `h-full`}  rounded-md border`}>
                        <div className="p-4">
                            <div className={"flex justify-between"}>
                                <h4 className="mb-4 text-[14px] font-bold leading-none">시스템 알림</h4>
                                <button className={"text-[12px] font-bold text-[#1c90fb] border-2 border-[#1c90fb] rounded-3xl px-2 mb-2 cursor-pointer hover:text-white hover:bg-[#1c90fb]"}
                                        onClick={handleReleaseAllCheck}>
                                    모두 읽음
                                </button>
                            </div>
                            <div className={`w-full h-[1px] bg-[#ccc] mt-[5px]`}></div>
                            <NotificationList notifications={notifications}/>
                            <div ref={ref}></div>
                        </div>
                    </ScrollArea>
                </div>
            )}
        </div>
    );
};

export default Notification;

const AlarmType = {
    APPROVER: "APPROVER",
    HANDLER: "HANDLER",
    VERIFIER : "VERIFIER",
    REJECT: "REJECT",
    REWORK_REQUEST : "REWORK_REQUEST",
}

const NotificationList = ({notifications}) => {
    const [data, setData] = useState([...notifications]);
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleMove = (location) => {
        navigate(`${location}`);
    }

    useEffect(() => {
        setData([...notifications]);
    }, [notifications.length]);

    const handleCheckingDone = async (id) => {
        const response = await releaseCheck(id);
        if (response && response.status === 200) {
            const list = data.filter(notification => notification.id !== id);
            setData([...list]);
            handleActiveToast({message: "읽음 처리되었습니다."});
        }
    }

    return (
        <>
            {data.length > 0 && data.map((notification, index) => (
                <div key={index}>
                    <div className={`flex my-2 gap-2 w-full`}>
                        {notification.alarmType === AlarmType.APPROVER && (
                            <div
                                className={`rounded-xl p-1 m-1`}
                                style={{ backgroundColor: t(`notification.backGround.${notification.contentCategory}`) }}
                            >
                                {<PencilSquareIcon className={`w-5 h-5 text-white`}/>}
                            </div>
                        )}
                        {notification.alarmType === AlarmType.HANDLER && (
                            <div
                                className={`rounded-xl p-1 m-1`}
                                style={{ backgroundColor: t(`notification.backGround.${notification.contentCategory}`) }}
                            >
                                {<WrenchIcon className={`w-5 h-5 text-white`}/>}
                            </div>
                        )}
                        {notification.alarmType === AlarmType.VERIFIER && (
                            <div
                                className={`bg-[#378ac5] rounded-2xl p-1 m-1`}
                                style={{ backgroundColor: t(`notification.backGround.${notification.contentCategory}`) }}
                            >
                                {<CheckIcon className={`w-5 h-5 text-white`}/>}
                            </div>
                        )}
                        {notification.alarmType === AlarmType.REJECT && (
                            <div className={`bg-[#d74b4b] rounded-2xl p-1 m-1`}>
                                {<BoltSlashIcon className={`w-5 h-5 text-white`}/>}
                            </div>
                        )}
                        {notification.alarmType === AlarmType.REWORK_REQUEST && (
                            <div
                                className={`rounded-xl p-1 m-1`}
                                style={{ backgroundColor: t(`notification.backGround.${notification.contentCategory}`) }}
                            >
                                {<WrenchIcon className={`w-5 h-5 text-white`}/>}
                            </div>
                        )}
                        <div className={"flex-1"}>
                            <div className={"text-[14px]"}>
                                {t(`notification.contentCategory.${notification.contentCategory}`)}
                            </div>
                            <div className={"flex justify-between"}>
                                <div className={`flex gap-3`}>
                                    <div className={`text-[12px]`}>
                                        {t(`notification.alarmType.${notification.alarmType}`)}
                                    </div>
                                    <div className={`text-[12px]`}>
                                        {notification.createdAt}
                                    </div>
                                </div>
                                <div className={`flex gap-4`}>
                                    <div className={`text-[10px] hover:underline cursor-pointer`}
                                         onClick={() => handleMove(notification.linkUrl)}>
                                        바로가기
                                    </div>
                                    <div className={`text-[10px] hover:underline cursor-pointer`}
                                         onClick={() => handleCheckingDone(notification.id)}>
                                        읽음
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`w-full h-[1px] bg-[#ccc] mt-[5px]`}></div>
                </div>
            ))}
            {data.length === 0 &&
                <div className={"my-10"}>
                    <img src={EmptyData} className="w-[40px] m-auto mb-3"/>
                    <div className={"text-center text-[15px]"}>새로운 알람이 없습니다.</div>
                </div>
            }
        </>
    )
}